(function () {'use strict';}());

angular.module('app').filter('questionType', function() {
    return function(listing,type) {
    	if(!listing) return listing;
        var trace = angular.trace;
    	var results = [];

    	for(var i = 0, count = listing.length; i < count; i++)
    	{
            var item = listing[i];
            if(item.type === type) results.push(item);
    	}

    	return results;
    };
});